import { useEffect } from "react";
const useDetectIframe = (handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (document.activeElement === document.querySelector("body")) {
        handler(event);
      }
    };
    window.addEventListener("blur", listener);
    return () => window.removeEventListener("blur", listener);
  }, []);
};
var useDetectIframe_default = useDetectIframe;
export {
  useDetectIframe_default as default
};
